import { render } from "./PosQueuePage.vue?vue&type=template&id=5fd439fc&scoped=true&ts=true"
import script from "./PosQueuePage.vue?vue&type=script&lang=ts"
export * from "./PosQueuePage.vue?vue&type=script&lang=ts"

import "./PosQueuePage.vue?vue&type=style&index=0&id=5fd439fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd439fc"]])

export default __exports__